<template>
  <div class="chart" ref="lineChart"></div>
</template>

<script>
import echarts from 'echarts';
import ChartStyleHelper from '@/helpers/chartStyleHelper';
import ChartFunctionHelper from '@/helpers/chartFunctionHelper';
import FuncHelper from '@/helpers/funcHelper';

export default {
  name: 'lineChart',
  props: {
    data: {
      type: Object,
      required: true
    },
    showSlider: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      chart: null
    };
  },
  methods: {
    chartOption() {
      const displayOptions = this.data.displayOptions;
      const grid = Object.assign({}, ChartStyleHelper.grid, {
        top: 16,
        left: 24,
        bottom: 16,
        right: 46
      });
      const tooltip = {
        trigger: 'axis',
        backgroundColor: '#ffffff',
        border: '1px solid #f7f7fa',
        boxShadow: '0px 6px 10px 0px',
        axisPointer: {
          type: 'line'
        },
        formatter(params) {
          return `<div style="color:#464d6c;font-size: 12px;margin:6px 8px;">${
            params[0].name
          }</div>${params
            .map(
              v => `<div style="color:#171f46;font-size: 14px;margin:8px;">${
                v.seriesName
              }:<span style="color:#ff9f5f;font-size: 14px;"> ${ChartStyleHelper.processDisplayOptions(
                v.data,
                displayOptions
              )}</span></div>`
            )
            .join('')}`;
        }
      };
      const dataPointCount = this.data.fields.length;
      const maxxAxisLabelCount = 5;
      const calcxAxisLabelCountIntervalThreshold = 10;
      const xAxisConfig = {
        type: 'category',
        data: this.data.fields.map(v => {
          return {
            value: v,
            textStyle: {
              fontSize: 12
            }
          };
        }),
        axisPointer: {
          type: 'line',
          lineStyle: {
            color: '#FF9F5F'
          }
        },
        axisLine: {
          lineStyle: {
            color: '#f7f7fa'
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: '#747990',
          fontSize: 12,
          fontFamily: 'Tahoma',
          showMinLabel: true,
          showMaxLabel: true,
          interval:
            dataPointCount > calcxAxisLabelCountIntervalThreshold
              ? Math.floor(dataPointCount / (maxxAxisLabelCount + 1))
              : 'auto'
        }
      };
      const yAxisConfig = {
        type: 'value',
        min: 'dataMin',
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        splitLine: {
          lineStyle: {
            // 使用深浅的间隔色
            color: '#f7f7fa'
          }
        },
        axisLabel: {
          color: '#747990',
          fontSize: 12,
          fontFamily: 'Tahoma',
          formatter: val => {
            return ChartStyleHelper.processDisplayOptions(val, displayOptions);
          }
        }
      };
      const option = {
        grid,
        tooltip,
        xAxis: [xAxisConfig],
        yAxis: [yAxisConfig],
        series: this.data.series.map(v => { 
          return {
            name: v.name,
            type: 'line',
            data: this.data.fields.map(field => v[field]),
            // symbol: 'image://data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTNweCIgaGVpZ2h0PSIxM3B4IiB2aWV3Qm94PSIwIDAgMTMgMTMiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzLjIgKDcyNjQzKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5PdmFsPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9InBhZ2UiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSIzdGFn6K+m5oOFIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE4OC4wMDAwMDAsIC0zNTIuMDAwMDAwKSIgZmlsbD0iIzNFM0M0MiIgZmlsbC1ydWxlPSJub256ZXJvIiBzdHJva2U9IiNGQjRCNTYiIHN0cm9rZS13aWR0aD0iNCI+CiAgICAgICAgICAgIDxnIGlkPSJQYXRoLTE0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5NTIuMDAwMDAwLCAyNjIuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBjeD0iMjQyLjUiIGN5PSI5Ni41IiByPSI0LjUiPjwvY2lyY2xlPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=',
            symbol: 'image://data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYxICg4OTU4MSkgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+5qSt5ZyG5b2iPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IlYzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0i5LqL5Lu26K+m5oOFIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzIxLjAwMDAwMCwgLTIwNC4wMDAwMDApIiBmaWxsPSIjRkZGRkZGIiBzdHJva2U9IiNGRjlGNUYiIHN0cm9rZS13aWR0aD0iNCI+CiAgICAgICAgICAgIDxnIGlkPSLnvJbnu4QtMTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyMC4wMDAwMDAsIDc2LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC0xNSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Iue8lue7hC0xMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTUuMDAwMDAwLCAxMjguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9IuakreWchuW9oiIgY3g9IjU1NCIgY3k9IjgiIHI9IjYiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+',
            symbolSize: 6,
            showSymbol: false,
            smooth: true,
            borderColor: 'white',
            areaStyle: {},
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0, color: '#ff9f5f' // 0% 处的颜色
              }, {
                offset: 1, color: 'rgba(255, 159, 95, 0.2)' // 100% 处的颜色
              }],
              global: false // 缺省为 false
            },
            borderWidth: 2,
            emphasis: {
              itemStyle: {
                borderColor: 'white'
              } 
            }
          };
        })
      };
      return option;
    },
    generateChart() {
      const lineChart = echarts.init(this.$refs.lineChart);
      const option = this.chartOption();
      lineChart.setOption(option);
      lineChart.on('finished', () => {
        const imgUrl = lineChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: '#fff'
        });
        this.$emit('done', imgUrl);
      });
      ChartFunctionHelper.preventLastSeriesUnseleted(lineChart);
      return lineChart;
    },
    resize() {
      if (this.chart) {
        FuncHelper.debounce(this.chart.resize, 300)();
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize);
    this.chart = this.generateChart();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    if (this.chart) {
      this.chart.dispose();
    }

    if (this.chart) {
      this.chart.off('finished');
    }
  }
};
</script>

<style lang="scss" scoped>
.chart{
  width:100%;
  height: 100%;
}
</style>
